export default function CookiePolicy() {
  return (
    <div className="container-vv py-20 max-w-4xl" data-testid="cookie-page">
      <div className="eyebrow">Cookie Policy</div>
      <h1 className="mt-3 font-display font-medium text-4xl sm:text-5xl text-[#292522]">Cookie Policy</h1>
      <div className="mt-6 rounded-2xl bg-[#FFF1E8] p-6 text-sm text-[#292522]/80">
        <strong>CONTENUTO PLACEHOLDER — DA SOTTOPORRE A VERIFICA LEGALE.</strong> Questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento. Nessun cookie di profilazione senza consenso.
      </div>
      <div className="mt-8 prose max-w-none text-[#292522]/85">
        <h2 className="font-display">Cookie tecnici</h2>
        <p>Utilizzati per la corretta navigazione, autenticazione al pannello admin e memorizzazione di preferenze minime. Non richiedono consenso.</p>
        <h2 className="font-display">Cookie di terze parti</h2>
        <p>Attualmente non utilizziamo servizi di analytics o profilazione. Se in futuro verranno introdotti, sarà mostrato un banner con opzioni di consenso granulare.</p>
        <h2 className="font-display">Gestione preferenze</h2>
        <p>Puoi bloccare i cookie direttamente dalle impostazioni del tuo browser.</p>
      </div>
    </div>
  );
}
